import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useState } from "react";
import { Toaster } from "react-hot-toast";

import SalesTable from "./Pages/AllTablesPage/SalesTable";
import PurchageTable from "./Pages/AllTablesPage/PurchaseTable";
import TabsButtonDashboard from "./Pages/Dashboard/TabsButton";
import TabsButtonGroup from "./Pages/TypesAndGroups/TabsButtonGroups";
import AddGroup from "./Pages/TypesAndGroups/Groups/AddGroup";
import AddSubGroup from "./Pages/TypesAndGroups/SubGroups/AddSubGroup";
import PaymentTable from "./Pages/AllTablesPage/PaymentTable";
import ReceiptTable from "./Pages/AllTablesPage/ReceiptTable";
import TypeDetails from "./Pages/TypesAndGroups/Types/TypeDetails";
import LedgerTables from "./Pages/TypesAndGroups/Ladgers/LedgerTables";
import LedgerDetails from "./Pages/TypesAndGroups/Ladgers/LedgerDetails";
import ProfitAndLoss from "./Pages/Reports/ProfitAndLoss";
import TabButtons from "./Pages/Reports/TabButtons";
import BalanceSheet from "./Pages/Reports/BalanceSheet";
import DashBoardData from "./Pages/DashBoardData/DashBoardData";
import JournalEntryTable from "./Pages/AllTablesPage/JournalEntryTable";
import GroupsTable from "./Pages/TypesAndGroups/Ladgers/GroupsTable";
import SubGroupsTable from "./Pages/TypesAndGroups/Ladgers/SubGroupsTable";
import TrialBalance from "./Pages/Reports/TrialBalance";
import ShowAllLedgers from "./Pages/TypesAndGroups/AllLedgers/ShowAllLedgers";
import Login from "./Components/Login/Login";
import WebSetting from './Pages/setting/WebSetting';
import Sidebar from "./Components/Sidebar/Sidebar";
import Navbar from "./Components/Navbar/Navbar";

// Auth
import { AuthProvider, useAuth } from "./Components/Login/AuthContext";
import { PrivateRoute } from "./Components/Login/PrivateRoute";
import { createContext } from "react";
import CombinePaymentReceipt from "./Pages/AllTablesPage/CombinePaymentReceipt";
import DailyReport from "./Pages/AllTablesPage/DailyReport";
import TabButtonSetting from "./Pages/setting/TabButtonSetting";
import AreasTable from "./Pages/setting/Areas/AreasTable";
import InventoryTable from "./Pages/InventoryBooks/InventoryTable";
import TabsButtonInventoryBook from "./Pages/TypesAndGroups/AccountBooksTab";
import TabsButtonAccountBook from "./Pages/TypesAndGroups/AccountBooksTab";
import NotFound from "./Components/Login/404Page";
import PLTabsButton from "./Pages/Reports/PLTabsButton";
import UtilisationReport from "./Pages/Reports/UtilisationReport";
import InventoryBookTabsButtons from "./Pages/InventoryBooks/InventoryBookTabsButtons";
import InventoryCategoryTable from "./Pages/InventoryBooks/InventoryCategoryTable";
import TabButtonUnderCreateTab from "./Pages/InventoryBooks/TabButtonUnderCreateTab";

import ItemsTable from "./Pages/InventoryBooks/Items/ItemsTable";
import CategoryTable from "./Pages/InventoryBooks/Category/CategoryTable";
import PaymentStructureTable from "./Pages/setting/PaymentStructure/PaymentStructureTable";
import ViewInventoryModal from "./Pages/InventoryBooks/ViewInventoryDetails";
import ManagerTable from "./Pages/setting/ManagerTable";
import WebGuideBook from "./Pages/GuideBook/WebGuideBook";
import TabButtonsTheftControl from "./Pages/setting/TheftControls/TabButtonsTheftControl";
import DeletedEntryData from "./Pages/setting/TheftControls/DeletedEntryData";
import UpdatedEntryData from "./Pages/setting/TheftControls/UpdatedEntryData";
import DeletedLedgersData from "./Pages/setting/TheftControls/DeletedLedgersData";
import StockTypeSubGroupTable from "./Pages/InventoryBooks/StockTypeSubGroupTable";
import SubCategoryTable from "./Pages/InventoryBooks/SubCategory/SubCategoryTable";
export const CommonContext = createContext()

function App() {
  const storedBranchId = localStorage.getItem("selectedBranchId");
  const [collapsed, setCollapsed] = useState(false);
  const [bank, setBank] = useState(0)
  const [cash, setCash] = useState(0)
  const [saleswithType, setSaleswithType] = useState([]);
  const [purchasewithItem, setPurchasewithItem] = useState([]);
  const [totalSales, setTotalSales] = useState(0)
  const [totalPurchase, setTotalPurchase] = useState(0)
  const [branchId, setBranchId] = useState(storedBranchId || null);
  const [branchExpireMSG, setBranchExpireMSG] = useState(false)
  const [branch, setBranch] = useState([]);
  const today = new Date();
  const formatDate = (date) => date.toISOString().split("T")[0];
  const currentYear = today.getFullYear();
  const aprilFirstCurrentYear = new Date(`${currentYear}-04-01`);
  const defaultStartYear = today >= aprilFirstCurrentYear ? currentYear : currentYear - 1;
const [singleDate, setSingleDate] = useState(() => {
  const today = new Date();
  return today.toISOString().split("T")[0];
});

  const [dateRange, setDateRange] = useState({
    startDate: '',
    endDate: '',
  });
  const [userData, setUserData] = useState({
    user: '',
    token: ''
  })
  return (
    <CommonContext.Provider value={{ bank, setBank, cash, setCash, branchId, setBranchId, userData, setUserData, branch, setBranch, saleswithType, setSaleswithType, purchasewithItem, setPurchasewithItem, totalSales, setTotalSales, totalPurchase, setTotalPurchase, dateRange, setDateRange, branchExpireMSG, setBranchExpireMSG }}>
      <AuthProvider>
        <Router>
          <AppContent collapsed={collapsed} setCollapsed={setCollapsed} />
        </Router>
      </AuthProvider>
    </CommonContext.Provider>
  );
}

// Separate component to use useAuth inside Router
function AppContent({ collapsed, setCollapsed }) {



  const { user } = useAuth();

  return (
    <div className="flex w-full transition-all duration-200 ease-in-out bg-[#f7f3ee]">
      {user && (
        <div className="px-2 pt-2 transition-all duration-200 ease-in-out">
          <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
        </div>
      )}

      <div
        className={`bg-[#f7f3ee] flex-1 min-h-screen transition-all duration-200 ease-in-out ${user ? (collapsed ? "ml-14  pt-2 pe-2" : "ml-40 xl:ml-48 pt-2 pe-2") : "ml-0"
          }`}
      >
        <Toaster position="top-right" reverseOrder={false} />


        <Routes>
          {/* Public login route */}
          <Route
            path="/login"
            element={user ? <Navigate to="/" replace /> : <Login />}
          />


          {/* Protected routes */}
          <Route
            path="/*"
            element={
              <PrivateRoute>


                <Routes>
                  <Route path="*" element={<NotFound />} />
                  <Route path="/" element={<DashBoardData />} />

                  <Route path="/dashboard" element={<TabsButtonDashboard />}>
                    {/* <Route index element={<CombinePaymentReceipt />} /> */}
                    <Route index element={<ReceiptTable />} />
                    <Route path="sales-table" element={<SalesTable />} />
                    <Route path="purchase-table" element={<PurchageTable />} />
                    <Route path="journal-entry" element={<JournalEntryTable />} />
                    <Route path="payment-transactions" element={<PaymentTable />} />
                    <Route path="receipt-transactions" element={<ReceiptTable />} />
                    <Route path="payment-receipt" element={<CombinePaymentReceipt />} />
                  </Route>

                  {/* Types & Groups */}
                  <Route path="/account-books" element={<TabsButtonAccountBook />}>
                    <Route index element={<GroupsTable />} />
                    <Route path="types-groups" element={<TabsButtonGroup />}>
                      <Route index element={<TypeDetails />} />
                      <Route path="group" element={<AddGroup />} />
                      <Route path="sub-group" element={<AddSubGroup />} />
                      <Route path="new-ladger" element={<ShowAllLedgers />} />
                      <Route path="types-details" element={<TypeDetails />} />
                    </Route>
                    <Route path="ledgers-table" element={<LedgerTables />} />
                    <Route path="sub-group-table" element={<SubGroupsTable />} />
                    <Route path="ledger-details" element={<LedgerDetails />} />
                    <Route path="groups-table" element={<GroupsTable />} />

                  </Route>

                  {/* Inventory Book */}
                  <Route path="/inventory-books" element={<InventoryBookTabsButtons />}>
                    <Route index element={<InventoryCategoryTable />} />
                    <Route path="category" element={<TabButtonUnderCreateTab />}>
                      <Route index element={<CategoryTable />} />
                      <Route path="sug-category-table" element={<SubCategoryTable />} />
                      <Route path="category-table" element={<CategoryTable />} />
                      <Route path="items" element={<ItemsTable />} />
                    </Route>
                    <Route path="item-details" element={<ViewInventoryModal />} />
                      <Route path="sub-category-table" element={<StockTypeSubGroupTable />} />
                    <Route path="inventory-category-table" element={<InventoryCategoryTable />} />
                    <Route path="inventory-items-table" element={<InventoryTable />} />
                  </Route>


                  {/* Reports */}
                  <Route path="/reports" element={<TabButtons />}>
                    <Route index element={<BalanceSheet />} />
                    <Route path="balance-sheet" element={<BalanceSheet />} />
                    <Route path="trial-balance" element={<TrialBalance />} />
                    <Route path="profit-loss" element={<PLTabsButton />} >
                      {user && user.role === "admin" &&
                        <Route index element={<ProfitAndLoss />} />}
                      <Route path="statement" element={<ProfitAndLoss />} />
                      <Route path="utilisation" element={<UtilisationReport />} />
                    </Route>
                  </Route>
              

                <Route path="/web-setting/manager" element={<ManagerTable />} />
                  <Route path="/web-setting/area-table" element={<AreasTable />} />
                  <Route path="/web-setting/payment-structure-table" element={<PaymentStructureTable />} />

                  <Route path="/daily-reports" element={<DailyReport />} />
                  <Route path="/web-setting" element={<WebSetting />} />
                  <Route path="/web-setting/guide-book" element={<WebGuideBook />} />


                    <Route path="/web-setting/theft-controls" element={<TabButtonsTheftControl/>}>
                    <Route index element={<DeletedEntryData />} />
                    <Route path="updated-entry" element={<UpdatedEntryData />} />
                    <Route path="deleted-ledgers" element={<DeletedLedgersData />} />
                    {/* <Route path="journal-entry" element={<JournalEntryTable />} /> */}
                    {/* <Route path="payment-transactions" element={<PaymentTable />} /> */}
                    <Route path="deleted-entry" element={<DeletedEntryData />} />
                    {/* <Route path="payment-receipt"  element={<CombinePaymentReceipt />} /> */}
                  </Route>

                </Routes>


              </PrivateRoute>
            }
          />
        </Routes>
      </div>
    </div>
  );
}

export default App;